import React from "react";
import { Link } from "react-router-dom";

const cardStyle: React.CSSProperties = {
  background: "#ffffff",
  border: "1px solid #e5e7eb",
  borderRadius: 18,
  padding: "1rem",
};

const gridStyle: React.CSSProperties = {
  display: "grid",
  gap: "1rem",
  gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
};

const statCardStyle: React.CSSProperties = {
  border: "1px solid #e5e7eb",
  borderRadius: 14,
  background: "#f8fafc",
  padding: "0.9rem 1rem",
};

const labelStyle: React.CSSProperties = {
  fontSize: "0.82rem",
  fontWeight: 700,
  color: "#64748b",
  textTransform: "uppercase",
  letterSpacing: "0.04em",
};

const valueStyle: React.CSSProperties = {
  marginTop: "0.35rem",
  color: "#0f172a",
  fontWeight: 700,
  lineHeight: 1.5,
};

const helperStyle: React.CSSProperties = {
  margin: "0.4rem 0 0",
  color: "#64748b",
  lineHeight: 1.6,
};

const complianceBadgeStyle: React.CSSProperties = {
  display: "inline-flex",
  alignItems: "center",
  padding: "0.35rem 0.7rem",
  borderRadius: 999,
  fontSize: "0.8rem",
  fontWeight: 700,
  background: "#fffbeb",
  color: "#92400e",
  border: "1px solid #fde68a",
};

export default function ProviderProfilePage() {
  const businessCategory = "Tattoo studio";
  const isComplianceSensitive = [
    "Tattoo studio",
    "PMU studio",
    "Piercing studio",
    "Aesthetics clinic",
  ].includes(businessCategory);

  return (
    <div style={{ display: "grid", gap: "1rem" }}>
      <section style={cardStyle}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            gap: "1rem",
            alignItems: "flex-start",
            flexWrap: "wrap",
          }}
        >
          <div>
            <h2 style={{ margin: 0, color: "#0f172a" }}>Provider profile</h2>
            <p style={{ margin: "0.5rem 0 0", color: "#475569", lineHeight: 1.7 }}>
              Manage business identity, contact information, location, category
              coverage, and public-facing profile content.
            </p>
          </div>

          {isComplianceSensitive ? (
            <span style={complianceBadgeStyle}>Compliance-sensitive category</span>
          ) : null}
        </div>
      </section>

      <section style={cardStyle}>
        <div style={gridStyle}>
          <div style={statCardStyle}>
            <div style={labelStyle}>Business name</div>
            <div style={valueStyle}>Demo provider business</div>
          </div>

          <div style={statCardStyle}>
            <div style={labelStyle}>Owner</div>
            <div style={valueStyle}>Demo owner</div>
          </div>

          <div style={statCardStyle}>
            <div style={labelStyle}>Business category</div>
            <div style={valueStyle}>{businessCategory}</div>
          </div>

          <div style={statCardStyle}>
            <div style={labelStyle}>Coverage</div>
            <div style={valueStyle}>Belfast and nearby areas</div>
          </div>

          <div style={statCardStyle}>
            <div style={labelStyle}>Status</div>
            <div style={valueStyle}>Draft onboarding in progress</div>
          </div>

          <div style={statCardStyle}>
            <div style={labelStyle}>Provider scope</div>
            <div style={valueStyle}>
              Tattoo & body art, Piercing, Aesthetics & cosmetic beauty
            </div>
          </div>
        </div>

        <p style={helperStyle}>
          The business category selected during onboarding should become the canonical
          provider classification used across review, search, internal approval, and
          future compliance workflows.
        </p>

        <div style={{ marginTop: "1rem" }}>
          <Link
            to="/provider/onboarding/profile"
            style={{
              textDecoration: "none",
              border: "1px solid #d1d5db",
              borderRadius: 12,
              padding: "0.8rem 1rem",
              color: "#111827",
              fontWeight: 700,
              display: "inline-flex",
            }}
          >
            Edit onboarding profile
          </Link>
        </div>
      </section>
    </div>
  );
}